// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgShieldCross = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.755 1.652a.6.6 0 0 1 .49 0l5.8 2.6a.6.6 0 0 1 .354.508l-.599.04.599-.04v.01l.002.022.004.083a15.792 15.792 0 0 1-.012 1.362c-.045.871-.175 2.045-.517 3.23-.34 1.179-.904 2.41-1.845 3.35C11.072 13.776 9.758 14.4 8 14.4c-1.758 0-3.074-.625-4.03-1.582-.942-.942-1.506-2.172-1.846-3.352-.342-1.184-.472-2.358-.517-3.23a15.816 15.816 0 0 1-.008-1.444l.002-.022V4.76L2.2 4.8l-.599-.04a.6.6 0 0 1 .354-.508l5.8-2.6ZM2.787 5.194v.002c-.004.235-.003.572.018.979.043.816.163 1.892.471 2.958.31 1.07.796 2.09 1.542 2.836.73.73 1.74 1.23 3.182 1.23s2.451-.5 3.182-1.23c.746-.746 1.232-1.766 1.542-2.836.308-1.066.428-2.142.47-2.958.022-.407.023-.744.02-.98L8 2.856 2.787 5.194Zm7.437.581a.6.6 0 0 1 0 .849L8.85 8l1.375 1.375a.6.6 0 0 1-.848.849L8 8.848l-1.376 1.376a.6.6 0 0 1-.848-.849L7.15 8 5.776 6.624a.6.6 0 1 1 .848-.849L8 7.151l1.376-1.376a.6.6 0 0 1 .848 0Z"
    />
  </svg>
)

export default SvgShieldCross
